module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-210.7635f213.jpg";